import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { ApiKeysPage, apiKeysQueryOptions } from '@/features/api-keys';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/api-keys')({
  staticData: { crumb: 'common:nav.apiKeys', tours: ['settings.api-keys'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'api_keys.manage');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...apiKeysQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: ApiKeysPage,
});
